// The dashboard's search field: a rounded box with a magnifier, its border
// taking the green accent while focused. `onChange(value, event)`. The
// browser's own suggestions (saved names and addresses) are off unless a
// caller asks for them.
// Sizes: sm (toolbars), md (lists and dialogs), lg (a page's one search).
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

const SIZES = {
    sm: { box: "h-[30px] gap-[7px] rounded-[7px] px-[9px]", icon: "h-[14px] w-[14px]", text: "text-[12.5px]" },
    md: { box: "h-[34px] gap-[9px] rounded-[8px] px-[11px]", icon: "h-[15px] w-[15px]", text: "text-[13px]" },
    lg: { box: "h-[46px] gap-[12px] rounded-[9px] px-[16px]", icon: "h-[17px] w-[17px]", text: "text-[15px]" },
};

export default function SearchInput({ value, onChange, placeholder = "Search", label = null, inputRef = null, size = "md", className = "", ...inputProps }) {
    const s = SIZES[size] ?? SIZES.md;
    return (
        <label className={`flex min-w-0 items-center border border-[color:var(--line)] bg-[color:var(--control-bg)] text-[color:var(--muted-soft)] transition-colors focus-within:border-[color:var(--green)] hover:border-[color:var(--line-strong)] ${s.box} ${className}`}>
            <MagnifyingGlassIcon aria-hidden="true" className={`shrink-0 ${s.icon}`} />
            <input
                ref={inputRef}
                type="search"
                value={value}
                onChange={(event) => onChange?.(event.target.value, event)}
                placeholder={placeholder}
                aria-label={label ?? placeholder}
                autoComplete="off"
                className={`min-w-0 flex-1 border-0 bg-transparent p-0 text-[color:var(--ink)] outline-none placeholder:text-[color:var(--muted-soft)] ${s.text}`}
                {...inputProps}
            />
        </label>
    );
}
